$(document).ready(function() {
  var lineCount = $('.artist-description .rte').height() / 28;
  if (lineCount < 6) {
    $('.artist-description .readmore').hide()
  }
  $('.artist-description .readmore').on('click', function() {
    $(this).parent().addClass('active');
  })
  $('.accordion').on('click', function() {
    $(this).toggleClass('active');
    document.querySelector('.readmore').style.setProperty('display', 'none', 'important');
  })
  $('.load-more').on('click', function() {
    $(this).closest('.images').find('.item').show()
    $(this).hide()
  })
})

$(function() {
  $('.loupe-form form').ebcaptcha();
});
(function($) {
  jQuery.fn.ebcaptcha = function(options) {
    var element = this;
    $('<label id="ebcaptchatext"></label>').appendTo($(this).find('.mathCaptcha'));
    $('<input type="text" class="textbox" id="ebcaptchainput" required data-error="Please solve the math problem."/><div class="help-block with-errors"></div>').appendTo($(this).find('.mathCaptcha'));
    var input = this.find('#ebcaptchainput');
    var label = this.find('#ebcaptchatext');
    $(element).find('button[type=submit]').attr('disabled', 'disabled');
    var randomNr1 = 0;
    var randomNr2 = 0;
    var totalNr = 0;
    randomNr1 = Math.floor(Math.random() * 10);
    randomNr2 = Math.floor(Math.random() * 10);
    totalNr = randomNr1 + randomNr2;
    var texti = randomNr1 + " + " + randomNr2 + " = ";
    $(label).text(texti);
    $(input).keyup(function() {
      var nr = $(this).val();
      if (nr == totalNr) {
        $(element).find('button[type=submit]').removeAttr('disabled');
      } else {
        $(element).find('button[type=submit]').attr('disabled', 'disabled');
      }
    });
    $(document).keypress(function(e) {
      if (e.which == 13) {
        if ((element).find('button[type=submit]').is(':disabled') === true) {
          e.preventDefault();
          return false;
        }
      }
    });
  };

})(jQuery);

$('.loupe-accordion .item .title').on('click', function() {
  $(this).parent().toggleClass('active')
  $(this).parent().find('.content').slideToggle();
});


window.addEventListener("load", function() {
  if (document.querySelector('.custom_readmore_btn') != null) {
    document.querySelector('.custom_readmore_btn').style.setProperty('display', 'block', 'important');
    document.querySelector('.custom_readmore_btn').addEventListener("click", function() {
      document.querySelector('.custom_readmore_btn').style.setProperty('display', 'none', 'important');
    });
  }
});

const multicolum_hover_swiper = new Swiper('.multicolumn-hover--cards', {
  cssMode: true,
  slidesPerView: 'auto',
  spaceBetween: 30,

  // If we need pagination
  pagination: {
    el: '.swiper-pagination',
    clickable: true
  },

  // Navigation arrows
  // navigation: {
  //   nextEl: '.swiper-button-next',
  //   prevEl: '.swiper-button-prev',
  // },

});
